import { render, staticRenderFns } from "./dynamic-data-details.vue?vue&type=template&id=70c92626&scoped=true"
import script from "./dynamic-data-details.vue?vue&type=script&lang=js"
export * from "./dynamic-data-details.vue?vue&type=script&lang=js"
import style0 from "./dynamic-data-details.vue?vue&type=style&index=0&id=70c92626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c92626",
  null
  
)

export default component.exports